import { useFormContext } from 'react-hook-form';
import { useEffect, useState, useCallback } from 'react';
import difference from 'lodash/difference';
import { Option } from '@mews-commander/types';

export interface ServicesPricingTables {
    list: Option[];
    currentService: string;
}

export const useSegmentedPropertiesTable = (optionsList: Option[], fieldPathKey: string) => {
    const { getValues, unregister, register, watch } = useFormContext();
    const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);

    const toggleSelection = useCallback(
        (selectedValues: string[]) => {
            if (!optionsList) return;

            const updatedOptions = optionsList.filter((option) => selectedValues.includes(option.value || ''));
            setSelectedOptions(updatedOptions);

            // Register missing selections and unregister those not in `selectedValues`
            const registeredItems = Object.keys(getValues(fieldPathKey) || {});
            difference(selectedValues, registeredItems).forEach((value) => register(`${fieldPathKey}.${value}`));
            difference(registeredItems, selectedValues).forEach((value) => unregister(`${fieldPathKey}.${value}`));
        },
        [fieldPathKey, optionsList, register, unregister, getValues]
    );

    useEffect(() => {
        const currentPropertiesIds = Object.keys(watch(fieldPathKey) || {});
        if (currentPropertiesIds.length > 0) {
            setSelectedOptions(optionsList.filter((option) => currentPropertiesIds.includes(option.value || '')));
        }
    }, [fieldPathKey, optionsList, watch]);

    return { selectedOptions, toggleSelection };
};
